import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import LoginLayout from '@src/Layouts/LoginLayout';
import MainLayout from '@src/Layouts/MainLayout';

import { UserInfoProvider } from '@src/store/UserInfoData/Provider';

import './App.less';
// antd 表单验证警告问题 问题参考 https://github.com/ant-design/ant-design/issues/26953
global.ASYNC_VALIDATOR_NO_WARNING = 1;


// require('leaflet/dist/leaflet.css');

const App = () => {

  return (
    <div>
      <Router>
        <Routes>
          <Route path="/login/*" element={<UserInfoProvider><LoginLayout /></UserInfoProvider>}></Route>
          <Route path="/*" element={<UserInfoProvider><MainLayout /></UserInfoProvider>}></Route>
        </Routes>
      </Router>
    </div>
  );
}


export default App;
